import React, { useState } from 'react';
import { Button, TextButton } from 'seagull';
import { InsightCard } from "../components/InsightCard";
import { SDALayout } from "../components/SDALayout";
import { useIoContext, useStoreActions } from "../../../contexts";
import { AgreementHeader } from "../../components/AgreementHeader";
import { StepPage } from "../../components/StepPage";
import { useRejectDeliveryModal } from "../components/RejectDeliveryModal";
import { DeliveryDetails } from "../components/DeliveryDetails";
import { Intent } from "../../../infra/access-control";
import { handleRequest } from "../../../infra/utils";
export function ViewButton(_ref) {
  let {
    file,
    showError,
    relationship,
    service,
    billCommand
  } = _ref;
  const {
    api
  } = useStoreActions();
  const {
    openNewTab
  } = useIoContext();
  if (!file) return null;

  async function openFile(fileId) {
    showError(false);
    const [file,, hasError] = await handleRequest(api.billCommand.getDeliverableUrl(relationship.id, service.id, billCommand.id, fileId));

    if (hasError) {
      showError(true);
    } else {
      openNewTab(file);
    }
  }

  return /*#__PURE__*/React.createElement(TextButton, {
    skin: "secondary",
    onClick: () => openFile(file.fileId),
    "data-testid": "sda-open-file-btn"
  }, "View");
}
export function ReviewDelivery(_ref2) {
  let {
    relationship,
    service,
    billCommand,
    onNextBtnClick,
    rejectDelivery
  } = _ref2;
  const [showError, setShowError] = useState(false);
  const openRejectModal = useRejectDeliveryModal({
    relationshipId: relationship.id,
    serviceId: service.id,
    billCommandId: billCommand.id,
    rejectDelivery
  });
  return /*#__PURE__*/React.createElement(StepPage, {
    relationship: relationship,
    header: "Review file and approve delivery",
    showError: showError,
    errorMessage: "An error has occurred. Please try again",
    errorTestid: "sda-review-error",
    primaryBtn: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      skin: "primaryOutline",
      intent: Intent.RejectDelivery,
      onClick: openRejectModal,
      "data-testid": "sda-reject-btn"
    }, "Reject delivery"), /*#__PURE__*/React.createElement(Button, {
      onClick: onNextBtnClick,
      "data-testid": "sda-review-next-btn"
    }, "Next"))
  }, /*#__PURE__*/React.createElement(SDALayout, null, /*#__PURE__*/React.createElement(AgreementHeader, {
    relationship: relationship,
    companyName: relationship.customer.name,
    isPreview: false
  }), /*#__PURE__*/React.createElement(DeliveryDetails, {
    service: service,
    billCommand: billCommand,
    FileButton: /*#__PURE__*/React.createElement(ViewButton, {
      relationship: relationship,
      service: service,
      billCommand: billCommand,
      showError: setShowError
    })
  }), /*#__PURE__*/React.createElement(InsightCard, null, "On the next page, you will be able to approve the files.")));
}